export default () => ({
  genderValue: null,
  rangeValue: 50,
  ticks: [0, 50, 100],
  range: null,
  isMobile: null,
  indicator: null,
  displayPrompt: null,
  display: false,
  customerId: null,
  genderInputRange: {
    [":style"]() {
      return { width: `${this.genderValue || "0"}%` };
    },
  },

  setInitialValues(isOverlay, customerID) {
    CF.customerReady(
      function () {
        const genderString = CF.customer.get("preference_gender") || null;

        if (!genderString && customerID.length > 0) {
          CF.customer.update({
            preference_gender: "unisex",
          });

          fetch(`${shopUrl}/apps/jl-api/frontend/klaviyo/profile`, {
            method: "PUT",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              data: {
                clothingGender: ["unisex"],
              },
            }),
          })
            .then((response) => {
              //return response.json();
            })
            .then((response) => {
              //console.log(response);
            });
        }

        if (genderString && isOverlay) {
          this.display = false;
        } else {
          this.display = true;
        }
      }.bind(this)
    );
  },
  initSlider(id) {
    this.customerId = id;
    CF.customerReady(
      function () {
        this.setIsMobile();
        const range = document.getElementById("genderInput");
        this.range = range;

        const genderString = CF.customer.get("preference_gender") || null;

        if (!genderString) {
          this.displayPrompt = true;
          this.range.classList.add("init");
        }

        const genderNumber =
          genderString == "womensClothing"
            ? 0
            : genderString == "mensClothing"
            ? 100
            : genderString == "unisex"
            ? 50
            : "unisex";
        //If none selected, should we set to unisex or null and prompt "choose"?

        this.genderValue = genderNumber;
      }.bind(this)
    );
  },

  getClosest(arr, val) {
    return arr.reduce(function (prev, curr) {
      return Math.abs(curr - val) < Math.abs(prev - val) ? curr : prev;
    });
  },

  setIsMobile() {
    this.isMobile = window.innerWidth < 1024 ? true : false;
  },

  setGenderValue(value) {
    const genderValue = this.getClosest(this.ticks, value);
    this.genderValue = genderValue;
    this.range.value = genderValue;
    this.range.classList.remove("init");
    this.displayPrompt = false;

    const genderString =
      genderValue == 0
        ? "womensClothing"
        : genderValue == 100
        ? "mensClothing"
        : "unisex";

    CF.customerReady(function () {
      CF.customer.update({
        preference_gender: genderString,
      });
    });
    if (this.customerId) {
      fetch(`${shopUrl}/apps/jl-api/frontend/klaviyo/profile`, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: {
            clothingGender: [genderString],
          },
        }),
      })
        .then((response) => {
          //return response.json();
        })
        .then((response) => {
          //console.log(response);
        });
    }
  },
});
